<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="headline">Porter</div>
                <br>

                <v-btn color="success" sx2 @click="showNewGate" :disabled="!isAdmin">
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    Ny port
                </v-btn>

                <v-row>
                    <v-col>
                        <v-data-table :headers="headers" :items="gates" :loading="gatesLoading" hide-default-footer :items-per-page="-1" class="ma-0 pa-0" :mobile-breakpoint="0">
                            <template v-slot:item={item}>
                                <tr @click="isAdmin? showEdit(item) : ''" :style="isAdmin ? 'cursor:pointer; white-space: nowrap': 'white-space: nowrap'">
                                    <td>
                                        <div class="d-flex">
                                            <v-icon v-if="hasProperty('nildevice_id', item) && item.nildevice_id">mdi-bluetooth</v-icon>
                                            {{item.name}}
                                        </div>

                                    </td>
                                    <td>{{item.directionText.text}}</td>
                                    <td>{{item.model}}</td>
                                    <td>{{item.serial}}</td>
                                    <td>{{isAdmin ? (!!item.unit ? item.unit.imei : '-') : '-'}}</td>
                                    <td>(+47) {{ !!item.unit? item.unit.simcard.number : '-'}}</td>
                                    <td>
                                        <div class="d-flex">
                                            <v-btn icon @click.stop="showEdit(item)" :disabled="!isAdmin">
                                                <v-icon color="info">mdi-pencil</v-icon>
                                            </v-btn>
                                            <v-btn icon @click.stop="showDeleteGate(item)" :disabled="!isAdmin">
                                                <v-icon color="info">mdi-delete</v-icon>
                                            </v-btn>
                                            <v-btn color="primary" icon @click.stop="showNilkeysDialog(item)">
                                                <v-icon>mdi-bluetooth</v-icon>
                                            </v-btn>
                                        </div>

                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>

                </v-row>
            </v-col>
        </v-row>

        <!-- <v-layout column>
            <h2>Porter</h2>
            <v-layout column>
                <v-toolbar>
                    <v-btn color="success" sx2 @click="showNewGate" :disabled="!isAdmin">
                        <v-icon left>mdi-plus-circle-outline</v-icon>
                        Ny port
                    </v-btn>
                </v-toolbar>

                <br>

                <v-data-table :headers="headers" :items="gates" :loading="gatesLoading" hide-default-footer :items-per-page="-1">
                    <template v-slot:item={item}>
                        <tr @click="isAdmin? showEdit(item) : ''" :style="isAdmin ? 'cursor:pointer': ''">
                            <td>
                                <v-icon v-if="hasProperty('nildevice_id', item) && item.nildevice_id">mdi-bluetooth</v-icon>
                                {{item.name}}
                            </td>
                            <td>{{item.directionText.text}}</td>
                            <td>{{item.model}}</td>
                            <td>{{item.serial}}</td>
                            <td>{{isAdmin ? (!!item.unit ? item.unit.imei : '-') : '-'}}</td>
                            <td>(+47) {{ !!item.unit? item.unit.simcard.number : '-'}}</td>
                            <td>
                                <v-btn icon @click.stop="showEdit(item)" :disabled="!isAdmin">
                                    <v-icon color="info">mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn icon @click.stop="showDeleteGate(item)" :disabled="!isAdmin">
                                    <v-icon color="info">mdi-delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>

            </v-layout>
        </v-layout> -->

        <v-dialog v-model="newGate.show">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Ny port
                </v-card-title>
                <v-card-text>
                    <v-form ref="newGate">
                        <v-text-field v-model="newGate.gate.name" label="Navn*" :rules="[v => !!v || 'Påkrevd']"></v-text-field>
                        <v-select v-model="newGate.gate.directionText" :items="directionsText" item-text="text" label="Retning*"></v-select>
                        <v-text-field v-model="newGate.gate.model" label="Type"></v-text-field>
                        <v-text-field v-model="newGate.gate.serial" label="Port serienummer" :rules="[v => !!v || 'Påkrevd']"></v-text-field>
                        <v-select v-model="newGate.gate.unit" :items="units" item-text="imei" label="Enhet IMEI*" :rules="[v => !!v || 'Påkrevd']" return-object>
                            <template slot="item" slot-scope="{item}">
                                <span>{{item.id}} - {{item.imei}}</span>
                            </template>
                        </v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="newGate.show = false">Avbryt</v-btn>
                    <v-btn @click="submitNewGate" color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="edit.show" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Rediger port: {{edit.gate.name}}
                </v-card-title>
                <v-card-text>
                    <v-form ref="editForm" v-model="edit.valid">
                        <v-text-field v-model="edit.gate.name" label="Navn" required></v-text-field>
                        <v-select v-model="edit.gate.directionText" item-text="text" :items="directionsText" label="Retning" return-object></v-select>
                        <v-text-field v-model="edit.gate.model" label="Type"></v-text-field>
                        <v-text-field v-model="edit.gate.serial" label="Port serienummer"></v-text-field>
                        <v-select v-model="edit.gate.unit" :items="units" item-text="imei" label="Enhet IMEI" return-object>
                            <template slot="item" slot-scope="{item}">
                                <span>{{item.id}} - {{item.imei}}</span>
                            </template>
                        </v-select>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeEdit">Avbryt</v-btn>
                    <v-btn @click="submitEdit" color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteGate.show" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Slett port: {{deleteGate.gate.name}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteGate.show = false">Avbryt</v-btn>
                    <v-btn @click="confirmDeleteGate" color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="nilkeys.showNilkeys">
            <v-card>
                <v-card-title class="grey lighten-2">
                    {{nilkeys.type == nilkeysType.NEW ? "New" : "Edit"}} Nilkeys device integration
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="nilkeys.deviceId" label="Device ID"></v-text-field>
                    <v-text-field v-model="nilkeys.deviceKey" label="Device KEY"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeNilkeysDialog()">avbryt</v-btn>
                    <v-btn v-if="nilkeys.type == nilkeysType.EDIT && !nilkeys.confirmDelete" @click="requestDeleteNilkeysDelete" color="error">slett</v-btn>
                    <v-btn v-if="nilkeys.type == nilkeysType.EDIT && nilkeys.confirmDelete" @click="deleteNilkeysDelete" color="error">er du sikker?</v-btn>
                    <v-btn color="primary" @click="saveNilkeysDevice()">{{nilkeys.type == nilkeysType.NEW ? "lage ny" : "rediger"}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
// import axios from "axios";
const nilkeysType = {
    NEW: 0,
    EDIT: 1,
    DELETE: 2,
    UNKNOWN: 3
};
export default {
    data() {
        return {
            nilkeys: {
                gateId: 0,
                showNilkeys: false,
                nilkeyDeviceId: 0,
                deviceId: undefined,
                deviceKey: undefined,
                type: nilkeysType.UNKNOWN,
                confirmDelete: false
            },
            nilkeysType: nilkeysType,

            gates: [],
            units: [],
            gatesLoading: false,
            headers: [
                { text: "Navn", value: "name" },
                { text: "Retning", value: "direction", sortable: false },
                { text: "Type", value: "model" },
                { text: "Serienummer", value: "serial", sortable: false },
                { text: "Enhet - IMEI", value: "unit", sortable: false },
                { text: "Simkort - tlfnr", value: "unit", sortable: false },
                { text: "Handlinger", sortable: false }
            ],
            directionsText: [
                { enum: 0, text: "INN" },
                { enum: 1, text: "UT" },
                { enum: 2, text: "TOVEIS" }
            ],
            deleteGate: {
                show: false,
                gate: {
                    id: 0,
                    name: ""
                }
            },
            newGate: {
                valid: false,
                show: false,
                gate: {
                    name: "",
                    serial: "",
                    model: "",
                    unit_id: 0,
                    direction: 2,
                    directionText: null
                }
            },
            edit: {
                valid: true,
                show: false,
                gate: {
                    id: 0,
                    name: "",
                    model: "",
                    serial: "",
                    direction: 0,
                    directionText: null,
                    unit_id: 0
                }
            }
        };
    },
    computed: {
        isAdmin: function() {
            // console.log(`admin -> ${this.$store.state.rights}`);
            return this.$store.state.rights == 0;
        }
    },
    methods: {
        showNilkeysDialog(gate) {
            this.nilkeys.gateId = gate.id;

            if (gate.nildevice) {
                this.nilkeys.nilkeyDeviceId = gate.nildevice.id;
                this.nilkeys.deviceId = gate.nildevice.deviceId;
                this.nilkeys.deviceKey = gate.nildevice.key;

                this.nilkeys.type = nilkeysType.EDIT;
            } else {
                this.nilkeys.type = nilkeysType.NEW;
            }

            this.nilkeys.showNilkeys = true;
        },
        closeNilkeysDialog() {
            this.nilkeys.gateId = 0;
            this.nilkeys.showNilkeys = false;
            this.nilkeys.deviceId = undefined;
            this.nilkeys.deviceKey = undefined;
            this.nilkeys.type = nilkeysType.UNKNOWN;
            this.nilkeys.confirmDelete = false;
            this.nilkeys.showNilkeys = false;
        },
        saveNilkeysDevice: function() {
            if (this.nilkeys.type === nilkeysType.NEW) {
                this.axios
                    .post("/nil/device", {
                        deviceId: this.nilkeys.deviceId,
                        deviceKey: this.nilkeys.deviceKey,
                        gateId: this.nilkeys.gateId
                    })
                    .then(() => {
                        this.loadGates();
                    });
            } else if (this.nilkeys.type === nilkeysType.EDIT) {
                this.axios
                    .put("/nil/device", {
                        nildevice: {
                            id: this.nilkeys.nilkeyDeviceId,
                            deviceId: this.nilkeys.deviceId,
                            key: this.nilkeys.deviceKey
                        }
                    })
                    .then(() => {
                        this.loadGates();
                    });
            }

            this.nilkeys.showNilkeys = false;
            // this.loadGates();
        },
        requestDeleteNilkeysDelete() {
            this.nilkeys.confirmDelete = true;
        },
        async deleteNilkeysDelete() {
            let gate = this.gates.find(g => g.id === this.nilkeys.gateId);
            await this.axios.delete(`/nil/device/${gate.nildevice.id}`);
            this.closeNilkeysDialog();
            this.loadGates();
        },
        hasProperty: function(property, item) {
            return item.hasOwnProperty(property);
        },
        showDeleteGate: function(gate) {
            Object.assign(this.deleteGate.gate, gate);
            this.deleteGate.show = true;
        },
        confirmDeleteGate: function() {
            this.axios
                .delete(`/gate/${this.deleteGate.gate.id}`)
                .then(response => {
                    if (response.data.success) {
                        let index = this.gates.findIndex(g => g.id == this.deleteGate.gate.id);
                        if (index >= 0) {
                            this.gates.splice(index, 1);
                            this.deleteGate.show = false;

                            this.$store.commit("snackbar", {
                                text: `Port ${this.deleteGate.gate.name} slettet.`,
                                color: "success",
                                show: true
                            });
                        }
                    } else {
                        this.$store.commit("snackbar", {
                            text: `Port ${this.deleteGate.gate.name} ikke slettet.`,
                            color: "error",
                            show: true
                        });
                    }
                })
                .catch(() => {
                    this.$store.commit("snackbar", {
                        text: `Port ${this.deleteGate.gate.name} ikke slettet.`,
                        color: "error",
                        show: true
                    });
                });
        },
        showNewGate: function() {
            let gate = this.newGate.gate;
            gate.name = "";
            gate.serial = "";
            gate.model = "";
            gate.unit_id = 0;
            gate.unit = null;
            gate.direction = 2;
            gate.directionText = this.directionsText.find(d => d.enum == gate.direction);

            this.newGate.show = true;
        },
        submitNewGate: function() {
            if (this.$refs.newGate.validate()) {
                let gate = this.newGate.gate;
                gate.unit_id = gate.unit.id;
                delete gate.unit;

                gate.direction = gate.directionText.enum;
                delete gate.directionText;

                this.axios
                    .put(`/gate?includes=unit.simcard`, gate)
                    .then(response => {
                        if (response.data.success) {
                            let newGate = response.data.data;
                            newGate.directionText = this.directionsText.find(d => d.enum == newGate.direction);
                            this.gates.push(newGate);

                            this.newGate.show = false;

                            this.$store.commit("snackbar", {
                                text: `Port ${newGate.name} lagret.`,
                                color: "success",
                                show: true
                            });
                        } else {
                            this.$store.commit("snackbar", {
                                text: `Port ikke lagret`,
                                color: "error",
                                show: true
                            });
                        }
                    })
                    .catch(() => {
                        this.$store.commit("snackbar", {
                            text: `Port $ikke lagret.`,
                            color: "error",
                            show: true
                        });
                    });
            } else {
                this.$store.commit("snackbar", {
                    text: `Port ikke gyldig.`,
                    color: "warning",
                    show: true
                });
            }
        },
        showEdit: function(gate) {
            Object.assign(this.edit.gate, gate);
            // this.edit.gate = gate;
            this.edit.show = true;
        },
        closeEdit: function() {
            this.edit.show = false;
        },
        submitEdit: function() {
            let gate = this.edit.gate;

            gate.direction = gate.directionText.enum;
            delete gate.directionText;

            gate.unit_id = gate.unit.id;
            delete gate.unit;

            this.axios
                .post(`/gate/${gate.id}?includes=unit.simcard`, gate)
                .then(response => {
                    if (response.data.success) {
                        let _gate = this.gates.find(g => g.id == gate.id);
                        Object.assign(_gate, gate);

                        let dtext = this.directionsText.find(d => d.enum == gate.direction);
                        this.$set(_gate, "directionText", dtext);

                        // _gate.unit = this.units.find(u => u.id == gate.unit_id);
                        // let index = this.gates.findIndex(g => g.id == gate.id);
                        // if (index >= 0) {
                        //     this.gates.splice(index, 1, gate);
                        // }

                        this.edit.show = false;

                        this.$store.commit("snackbar", {
                            text: `Port ${gate.name} redigert.`,
                            color: "success",
                            show: true
                        });
                    } else {
                        this.$store.commit("snackbar", {
                            text: `Port ${gate.name} ikke redigert.`,
                            color: "error",
                            show: true
                        });
                    }
                })
                .catch(() => {
                    this.$store.commit("snackbar", {
                        text: `Port ${gate.name} ikke redigert.`,
                        color: "error",
                        show: true
                    });
                });
        },
        loadGates: function() {
            this.gatesLoading = true;
            this.axios
                .get(`/gate?includes=unit.simcard,nildevice`)
                .then(response => {
                    if (response.data.success) {
                        let _gates = response.data.data;
                        _gates.forEach(g => {
                            g.directionText = this.directionsText.find(d => d.enum == g.direction);
                        });
                        this.gates = _gates.sort((a, b) => {
                            if (a.name < b.name) return -1;
                            else if (a.name > b.name) return 1;
                            else return 0;
                        });
                        // console.log(this.gates);
                    }
                })
                .finally(() => {
                    this.gatesLoading = false;
                });

            this.axios.get(`/unit`).then(response => {
                if (response.data.success) {
                    this.units = response.data.data;
                }
            });
        }
    },
    mounted() {
        this.loadGates();
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style lang="scss" scoped>
</style>
